function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var tokens = {
  border_radius_none: "0rem",
  border_radius_small: "0.5rem",
  border_radius_medium: "0.75rem",
  border_radius_large: "1rem",
  border_radius_default: "0.75rem",
  border_width_default: "0.125rem",
  border_width_thick: "0.125rem",
  border_width_extra_thick: "0.25rem",
  input_border_radius: "0.5rem",
  input_border_width: "0.125rem",
  input_width_default: "19.5rem",
  breakpoint_xs: "0rem",
  breakpoint_sm: "22.5rem",
  breakpoint_md: "48rem",
  breakpoint_lg: "64rem",
  breakpoint_xl: "85.375rem",
  spacing_10: "6rem",
  spacing_none: "0rem",
  spacing_01: "0.25rem",
  spacing_02: "0.5rem",
  spacing_03: "0.75rem",
  spacing_04: "1rem",
  spacing_05: "1.5rem",
  spacing_06: "2rem",
  spacing_07: "2.5rem",
  spacing_08: "3rem",
  spacing_09: "4rem",
  typography_font_size_s1: "1rem",
  typography_font_size_s2: "1.125rem",
  typography_font_size_s3: "1.25rem",
  typography_font_size_s4: "1.5rem",
  typography_font_size_s5: "2rem",
  typography_font_size_s6: "2.25rem",
  typography_font_size_s7: "2.5rem",
  typography_font_size_s7_md: "3rem",
  typography_font_size_s8: "2.5rem",
  typography_font_size_s8_md: "3rem",
  typography_font_size_s9: "2.5rem",
  typography_font_size_s9_md: "3rem",
  typography_font_size_s10: "2.5rem",
  typography_font_size_s10_md: "3rem",
  typography_line_height_s1: "1.25rem",
  typography_line_height_s2: "1.5rem",
  typography_line_height_s3: "1.75rem",
  typography_line_height_s4: "1.75rem",
  typography_line_height_s5: "2.25rem",
  typography_line_height_s6: "2.5rem",
  typography_line_height_s7: "3rem",
  typography_line_height_s7_md: "3.25rem",
  typography_line_height_s8: "3rem",
  typography_line_height_s8_md: "3.25rem",
  typography_line_height_s9: "3rem",
  typography_line_height_s9_md: "3.25rem",
  typography_line_height_s10: "3rem",
  typography_line_height_s10_md: "3.25rem",
  typography_heading_font_size_s2: "1.125rem",
  typography_heading_font_size_s3: "1.25rem",
  typography_heading_font_size_s4: "1.5rem",
  typography_heading_font_size_s5: "2rem",
  typography_heading_font_size_s6: "2.25rem",
  typography_heading_font_size_s7: "2.5rem",
  typography_heading_font_size_s7_md: "3rem",
  typography_heading_line_height_s2: "1.5rem",
  typography_heading_line_height_s3: "1.75rem",
  typography_heading_line_height_s4: "1.75rem",
  typography_heading_line_height_s5: "2.25rem",
  typography_heading_line_height_s6: "2.5rem",
  typography_heading_line_height_s7: "3rem",
  typography_heading_line_height_s7_md: "3.25rem",
  typography_text_font_size_s1: "1rem",
  typography_text_font_size_s2: "1.125rem",
  typography_text_font_size_s3: "1.25rem",
  typography_text_font_size_s4: "1.5rem",
  typography_text_font_size_s5: "2rem",
  typography_text_line_height_s1: "1.25rem",
  typography_text_line_height_s2: "1.5rem",
  typography_text_line_height_s3: "1.75rem",
  typography_text_line_height_s4: "1.75rem",
  typography_text_line_height_s5: "2.25rem",
  accordion_button_size_border_radius: "0.5rem",
  accordion_inpage1_button_size_padding_horizontal: "0rem",
  accordion_inpage1_button_size_padding_horizontal_md: "0rem",
  accordion_inpage1_button_size_padding_vertical: "0.75rem",
  accordion_inpage1_button_size_padding_vertical_md: "1rem",
  accordion_inpage1_size_border_width: "0.0625rem",
  accordion_inpage2_button_size_padding_horizontal: "0rem",
  accordion_inpage2_button_size_padding_horizontal_md: "0rem",
  accordion_inpage2_button_size_padding_vertical: "0.75rem",
  accordion_inpage2_button_size_padding_vertical_md: "1rem",
  accordion_standalone_size_border_radius: "0.5rem",
  accordion_standalone_button_size_padding_horizontal: "0.75rem",
  accordion_standalone_button_size_padding_horizontal_md: "1.5rem",
  accordion_standalone_button_size_padding_vertical: "0.75rem",
  accordion_standalone_button_size_padding_vertical_md: "1rem",
  box_border_radius_none: "0rem",
  box_border_radius_tight: "0.5rem",
  box_border_radius_default: "0.5rem",
  box_border_width: "0.125rem",
  box_padding: "0.75rem",
  box_padding_md: "1.5rem",
  button_border_radius: "1.5rem",
  button_border_width: "0.125rem",
  button_min_width: "6.25rem",
  button_padding_horizontal: "1.5rem",
  button_padding_vertical: "0.75rem",
  checkbox_appearance_size: "2rem",
  checkbox_appearance_margin_right: "0.75rem",
  checkbox_margin_bottom: "0.75rem",
  dialog_border_radius: "0.5rem",
  dialog_padding: "0.75rem",
  dialog_padding_wide: "1.5rem",
  dialog_max_width: "31.25rem",
  errorsummary_border_radius: "0.5rem",
  errorsummary_border_width: "0.125rem",
  grid_gutter_width: "1.5rem",
  header_height: "4rem",
  header_height_big: "6rem",
  header_logo_height: "3rem",
  header_logo_height_big: "2.875rem",
  header_logo_width: "6.5625rem",
  header_logo_width_big: "10.125rem",
  header_logo_margin: "0.5rem",
  header_logo_margin_big: "1.25rem",
  header_auth_padding_logout: "1.2812rem",
  header_auth_padding_home: "1.375rem",
  heading_margin_bottom_default: "1.5rem",
  heading_s2_font_size: "1.125rem",
  heading_s2_line_height: "1.5rem",
  heading_s3_font_size: "1.25rem",
  heading_s3_line_height: "1.75rem",
  heading_s4_font_size: "1.5rem",
  heading_s4_line_height: "1.75rem",
  heading_s5_font_size: "2rem",
  heading_s5_line_height: "2.25rem",
  heading_s6_font_size: "2.25rem",
  heading_s6_line_height: "2.5rem",
  heading_s7_font_size: "2.5rem",
  heading_s7_font_size_md: "3rem",
  heading_s7_line_height: "3rem",
  heading_s7_line_height_md: "3.25rem",
  hr_spacing: "1.5rem",
  hr_width: "0.0625rem",
  link_text_underline_offset: "0.1875rem",
  notification_icon_height: "1.875rem",
  notification_icon_padding_bottom_mobile: "1rem",
  notification_standalone_body_border_width: "0rem",
  notification_standalone_body_no_title_padding_left: "0.125rem",
  notification_standalone_body_no_title_padding_top: "0.125rem",
  notification_standalone_body_padding_bottom_mobile: "0.75rem",
  notification_standalone_body_padding_left: "2.75rem",
  notification_standalone_body_padding_left_mobile: "0rem",
  notification_standalone_body_padding_top: "1.5rem",
  notification_standalone_body_padding_top_mobile: "1.5rem",
  notification_standalone_border_width: "0rem",
  notification_standalone_container_border_radius: "0.5rem",
  notification_standalone_container_border_width: "0.125rem",
  notification_standalone_no_children_border_width: "0rem",
  radiobutton_checked_border_width: "0.62rem",
  radiobutton_margin_top: "0.25rem",
  radiobutton_margin_bottom: "0.75rem",
  radiobutton_text_margin_left: "0.6rem",
  radiobutton_text_margin_top: "0.3rem",
  selector_minus_margin_left: "-0.125rem",
  summarybox_border_radius: "0.5rem",
  summarybox_border_width: "0.125rem",
  table_size_border_radius: "0.5rem",
  tabs_inpage_accordion_tabs_size_border_width_bottom: "0.125rem",
  tabs_inpage_accordion_tab_size_border_radius: "0rem",
  tabs_inpage_accordion_tab_size_border_width_bottom: "0.125rem",
  tabs_inpage_accordion_tab_size_border_selected_width_top: "0.125rem",
  tabs_inpage_tab_size_border_radius: "0rem",
  tabs_inpage_tab_size_border_width_bottom: "0.125rem",
  tabs_inpage_tab_size_border_selected_width_bottom: "0.25rem",
  tabs_standalone_tab_size_border_radius: "0.75rem",
  tabs_standalone_tab_size_border_width: "0.125rem",
  tabs_standalone_tab_size_spacing_left: "0.25rem",
  tabs_standalone_tab_size_spacing_right: "0.25rem",
  text_s1_font_size: "1rem",
  text_s1_line_height: "1.25rem",
  text_s2_font_size: "1.125rem",
  text_s2_line_height: "1.5rem",
  text_s3_font_size: "1.25rem",
  text_s3_line_height: "1.75rem",
  text_s4_font_size: "1.5rem",
  text_s4_line_height: "1.75rem",
  text_s5_font_size: "2rem",
  text_s5_line_height: "2.25rem",
  textarea_size_height: "6rem",
  tooltip_overlay_size_border_radius: "0.5rem",
  numberfield_border_radius: "0.375rem",
  numberfield_border_radius_down: "0.375rem 0 0 0.375rem",
  numberfield_border_radius_up: "0 0.375rem 0.375rem 0",
  color_source_primary_1: "#107987",
  color_source_primary_2: "#0c5963",
  color_source_primary_3: "#a8e700",
  color_source_primary_4: "#e6f3f6",
  color_source_secondary_1: "#4e75af",
  color_source_secondary_2: "#00284c",
  color_source_secondary_3: "#365c7d",
  color_source_white: "#ffffff",
  color_source_grey_100: "#f1f1f1",
  color_source_grey_200: "#adadad",
  color_source_grey_300: "#767676",
  color_source_grey_400: "#505050",
  color_source_grey_500: "#323233",
  color_source_grey_alpha_300: "rgba(51, 51, 51, 0.64)",
  color_source_black: "#000000",
  color_source_black_alpha_100: "rgba(0, 0, 0, 0.08)",
  color_source_black_alpha_200: "rgba(0, 0, 0, 0.12)",
  color_source_black_alpha_300: "rgba(0, 0, 0, 0.2)",
  color_source_red_100: "#fae9ec",
  color_source_red_500: "#ce2244",
  color_source_green_100: "#ecf2ec",
  color_source_green_500: "#427d3e",
  color_source_orange_100: "#faede6",
  color_source_orange_500: "#cc4e00",
  color_source_blue_100: "#e7f0f4",
  color_source_blue_500: "#0d6c95",
  color_text_default_1: "#00284c",
  color_text_default_2: "#00284c",
  color_text_brand_1: "#107987",
  color_text_subdued: "#767676",
  color_text_critical: "#ce2244",
  color_text_inverse_brand_1: "#ffffff",
  color_text_inverse_default_1: "#ffffff",
  color_icon_default_1: "#107987",
  color_icon_default_2: "#00284c",
  color_icon_subdued: "#767676",
  color_icon_critical: "#ce2244",
  color_icon_warning: "#cc4e00",
  color_icon_success: "#427d3e",
  color_icon_information: "#0d6c95",
  color_icon_inverse_brand_1: "#a8e700",
  color_icon_inverse_default_1: "#ffffff",
  color_border_default_1: "#00284c",
  color_border_default_2: "#adadad",
  color_border_brand_1: "#107987",
  color_border_critical: "#ce2244",
  color_border_warning: "#cc4e00",
  color_border_success: "#427d3e",
  color_border_information: "#0d6c95",
  color_border_inverse_brand_1: "#ffffff",
  color_border_inverse_default_1: "#ffffff",
  color_background_neutral_1: "#ffffff",
  color_background_neutral_2: "#e6f3f6",
  color_background_overlay_1: "rgba(51, 51, 51, 0.64)",
  color_background_page_1: "#ffffff",
  color_background_page_2: "#ffffff",
  color_background_panel_neutral_1: "#e6f3f6",
  color_background_panel_neutral_2: "#ffffff",
  color_background_panel_brand_1: "#107987",
  color_background_panel_brand_2: "#0c5963",
  color_background_panel_brand_3: "#00284c",
  color_background_panel_brand_4: "#365c7d",
  color_background_panel_critical: "#fae9ec",
  color_background_panel_warning: "#faede6",
  color_background_panel_success: "#ecf2ec",
  color_background_panel_information: "#e7f0f4",
  color_background_section_neutral_1: "#e6f3f6",
  color_background_section_neutral_2: "#ffffff",
  color_background_section_brand_1: "#107987",
  color_background_section_brand_2: "#0c5963",
  color_background_section_brand_3: "#00284c",
  color_background_section_brand_4: "#365c7d",
  color_action_background_primary_default: "#107987",
  color_action_background_primary_hover: "#0c5963",
  color_action_background_primary_pressed: "#4e75af",
  color_action_background_primary_focus: "#4e75af",
  color_action_background_primary_disabled: "#f1f1f1",
  color_action_background_secondary_default: "rgba(0, 0, 0, 0)",
  color_action_background_secondary_hover: "#ffffff",
  color_action_background_secondary_pressed: "#4e75af",
  color_action_background_secondary_focus: "#4e75af",
  color_action_background_secondary_disabled: "#f1f1f1",
  color_action_background_tertiary_default: "rgba(0, 0, 0, 0)",
  color_action_background_tertiary_hover: "rgba(0, 0, 0, 0)",
  color_action_background_tertiary_pressed: "#4e75af",
  color_action_background_tertiary_focus: "#4e75af",
  color_action_background_tertiary_disabled: "#f1f1f1",
  color_action_border_primary_default: "#107987",
  color_action_border_primary_hover: "#0c5963",
  color_action_border_primary_pressed: "#4e75af",
  color_action_border_primary_focus: "#4e75af",
  color_action_border_primary_disabled: "#f1f1f1",
  color_action_border_secondary_default: "#107987",
  color_action_border_secondary_hover: "#0c5963",
  color_action_border_secondary_pressed: "#4e75af",
  color_action_border_secondary_focus: "#4e75af",
  color_action_border_secondary_disabled: "#f1f1f1",
  color_action_border_tertiary_default: "rgba(0, 0, 0, 0)",
  color_action_border_tertiary_hover: "rgba(0, 0, 0, 0)",
  color_action_border_tertiary_pressed: "#4e75af",
  color_action_border_tertiary_focus: "#4e75af",
  color_action_border_tertiary_disabled: "#f1f1f1",
  color_action_decoration_focus_ring_1: "#4e75af",
  color_action_decoration_focus_ring_2: "#ffffff",
  color_action_foreground_primary_default: "#ffffff",
  color_action_foreground_primary_hover: "#ffffff",
  color_action_foreground_primary_pressed: "#ffffff",
  color_action_foreground_primary_focus: "#ffffff",
  color_action_foreground_primary_disabled: "#767676",
  color_action_foreground_secondary_default: "#107987",
  color_action_foreground_secondary_hover: "#0c5963",
  color_action_foreground_secondary_pressed: "#ffffff",
  color_action_foreground_secondary_focus: "#ffffff",
  color_action_foreground_secondary_disabled: "#767676",
  color_action_foreground_tertiary_default: "#107987",
  color_action_foreground_tertiary_hover: "#0c5963",
  color_action_foreground_tertiary_pressed: "#ffffff",
  color_action_foreground_tertiary_focus: "#ffffff",
  color_action_foreground_tertiary_disabled: "#767676",
  color_action_foreground_tertiary_alternate_default: "#00284c",
  color_action_foreground_tertiary_alternate_hover: "#00284c",
  color_action_foreground_tertiary_alternate_pressed: "#ffffff",
  color_action_foreground_tertiary_alternate_focus: "#ffffff",
  color_action_foreground_tertiary_alternate_disabled: "#adadad",
  color_action_inverse_background_primary_default: "#ffffff",
  color_action_inverse_background_primary_hover: "#ffffff",
  color_action_inverse_background_primary_pressed: "#4e75af",
  color_action_inverse_background_primary_focus: "#4e75af",
  color_action_inverse_background_primary_disabled: "#f1f1f1",
  color_action_inverse_background_primary_accent_default: "#a8e700",
  color_action_inverse_background_primary_accent_hover: "#a8e700",
  color_action_inverse_background_primary_accent_pressed: "#4e75af",
  color_action_inverse_background_primary_accent_focus: "#4e75af",
  color_action_inverse_background_primary_accent_disabled: "#f1f1f1",
  color_action_inverse_background_secondary_default: "rgba(0, 0, 0, 0)",
  color_action_inverse_background_secondary_hover: "rgba(0, 0, 0, 0)",
  color_action_inverse_background_secondary_pressed: "#4e75af",
  color_action_inverse_background_secondary_focus: "#4e75af",
  color_action_inverse_background_secondary_disabled: "#f1f1f1",
  color_action_inverse_background_tertiary_default: "rgba(0, 0, 0, 0)",
  color_action_inverse_background_tertiary_hover: "rgba(0, 0, 0, 0)",
  color_action_inverse_background_tertiary_pressed: "#4e75af",
  color_action_inverse_background_tertiary_focus: "#4e75af",
  color_action_inverse_background_tertiary_disabled: "#f1f1f1",
  color_action_inverse_border_primary_default: "#ffffff",
  color_action_inverse_border_primary_hover: "#ffffff",
  color_action_inverse_border_primary_pressed: "#4e75af",
  color_action_inverse_border_primary_focus: "#4e75af",
  color_action_inverse_border_primary_disabled: "#f1f1f1",
  color_action_inverse_border_primary_accent_default: "#a8e700",
  color_action_inverse_border_primary_accent_hover: "#a8e700",
  color_action_inverse_border_primary_accent_pressed: "#4e75af",
  color_action_inverse_border_primary_accent_focus: "#4e75af",
  color_action_inverse_border_primary_accent_disabled: "#f1f1f1",
  color_action_inverse_border_secondary_default: "#ffffff",
  color_action_inverse_border_secondary_hover: "#ffffff",
  color_action_inverse_border_secondary_pressed: "#4e75af",
  color_action_inverse_border_secondary_focus: "#4e75af",
  color_action_inverse_border_secondary_disabled: "#f1f1f1",
  color_action_inverse_border_tertiary_default: "rgba(0, 0, 0, 0)",
  color_action_inverse_border_tertiary_hover: "rgba(0, 0, 0, 0)",
  color_action_inverse_border_tertiary_pressed: "#4e75af",
  color_action_inverse_border_tertiary_focus: "#4e75af",
  color_action_inverse_border_tertiary_disabled: "#f1f1f1",
  color_action_inverse_decoration_focus_ring_1: "#4e75af",
  color_action_inverse_decoration_focus_ring_2: "#ffffff",
  color_action_inverse_foreground_primary_default: "#107987",
  color_action_inverse_foreground_primary_hover: "#0c5963",
  color_action_inverse_foreground_primary_pressed: "#ffffff",
  color_action_inverse_foreground_primary_focus: "#ffffff",
  color_action_inverse_foreground_primary_disabled: "#767676",
  color_action_inverse_foreground_primary_accent_default: "#00284c",
  color_action_inverse_foreground_primary_accent_hover: "#00284c",
  color_action_inverse_foreground_primary_accent_pressed: "#ffffff",
  color_action_inverse_foreground_primary_accent_focus: "#ffffff",
  color_action_inverse_foreground_primary_accent_disabled: "#767676",
  color_action_inverse_foreground_secondary_default: "#ffffff",
  color_action_inverse_foreground_secondary_hover: "#ffffff",
  color_action_inverse_foreground_secondary_pressed: "#ffffff",
  color_action_inverse_foreground_secondary_focus: "#ffffff",
  color_action_inverse_foreground_secondary_disabled: "#767676",
  color_action_inverse_foreground_tertiary_default: "#ffffff",
  color_action_inverse_foreground_tertiary_hover: "#ffffff",
  color_action_inverse_foreground_tertiary_pressed: "#ffffff",
  color_action_inverse_foreground_tertiary_focus: "#ffffff",
  color_action_inverse_foreground_tertiary_disabled: "#767676",
  color_input_border_default: "#107987",
  color_input_border_disabled: "#505050",
  color_input_border_focus: "#4e75af",
  color_input_border_hover: "#0c5963",
  color_input_border_critical: "#ce2244",
  color_input_border_success: "#427d3e",
  color_input_background_default: "#ffffff",
  color_input_background_hover: "#ffffff",
  color_input_background_focus: "#ffffff",
  color_input_background_disabled: "#f1f1f1",
  color_input_decoration_focus_ring_1: "#4e75af",
  color_input_decoration_focus_ring_2: "#ffffff",
  color_input_markers_checked_1: "#107987",
  color_input_markers_checked_2: "#0c5963",
  accordion_inpage1_button_color_background: "#ffffff",
  accordion_inpage1_button_color_border: "#adadad",
  accordion_inpage1_button_color_text_default: "#107987",
  accordion_inpage1_button_color_text_focus: "#0c5963",
  accordion_inpage1_button_color_text_hover: "#0c5963",
  accordion_inpage1_button_color_text_pressed: "#0c5963",
  accordion_inpage1_button_color_icon_default: "#107987",
  accordion_inpage1_button_color_icon_focus: "#0c5963",
  accordion_inpage1_button_color_icon_hover: "#0c5963",
  accordion_inpage1_button_color_icon_pressed: "#0c5963",
  accordion_inpage2_button_color_background: "#ffffff",
  accordion_inpage2_button_color_border: "rgba(0, 0, 0, 0)",
  accordion_inpage2_button_color_text_default: "#107987",
  accordion_inpage2_button_color_text_focus: "#0c5963",
  accordion_inpage2_button_color_text_hover: "#0c5963",
  accordion_inpage2_button_color_text_pressed: "#0c5963",
  accordion_inpage2_button_color_icon_default: "#107987",
  accordion_inpage2_button_color_icon_focus: "#0c5963",
  accordion_inpage2_button_color_icon_hover: "#0c5963",
  accordion_inpage2_button_color_icon_pressed: "#0c5963",
  accordion_standalone_button_color_background: "#e6f3f6",
  accordion_standalone_button_color_border: "#e6f3f6",
  accordion_standalone_button_color_text_default: "#107987",
  accordion_standalone_button_color_text_focus: "#0c5963",
  accordion_standalone_button_color_text_hover: "#0c5963",
  accordion_standalone_button_color_text_pressed: "#0c5963",
  accordion_standalone_button_color_icon_default: "#107987",
  accordion_standalone_button_color_icon_focus: "#0c5963",
  accordion_standalone_button_color_icon_hover: "#0c5963",
  accordion_standalone_button_color_icon_pressed: "#0c5963",
  accordion_standalone_body_color_background: "#e6f3f6",
  box_color_background_brand1: "#107987",
  box_color_background_brand2: "#0c5963",
  box_color_background_critical: "#fae9ec",
  box_color_background_neutral1: "#e6f3f6",
  box_color_background_neutral2: "#ffffff",
  box_color_background_information: "#e7f0f4",
  box_color_background_none: "rgba(0, 0, 0, 0)",
  box_color_background_success: "#ecf2ec",
  box_color_background_warning: "#faede6",
  box_color_background_brand3: "#00284c",
  box_color_background_brand4: "#365c7d",
  box_color_border_critical: "#ce2244",
  box_color_border_information: "#0d6c95",
  box_color_border_success: "#427d3e",
  box_color_border_warning: "#cc4e00",
  box_color_critical_action_default: "#00284c",
  box_color_critical_action_focus: "#ffffff",
  box_color_critical_action_hover: "#00284c",
  box_color_critical_action_pressed: "#ffffff",
  box_color_information_action_default: "#00284c",
  box_color_information_action_focus: "#ffffff",
  box_color_information_action_hover: "#00284c",
  box_color_information_action_pressed: "#ffffff",
  box_color_success_action_default: "#00284c",
  box_color_success_action_focus: "#ffffff",
  box_color_success_action_hover: "#00284c",
  box_color_success_action_pressed: "#ffffff",
  box_color_warning_action_default: "#00284c",
  box_color_warning_action_focus: "#ffffff",
  box_color_warning_action_hover: "#00284c",
  box_color_warning_action_pressed: "#ffffff",
  dialog_color_background: "#ffffff",
  dialog_color_close: "#107987",
  footer_color_background: "#00284c",
  header_color_background: "#00284c",
  header_color_button_separator: "#ffffff",
  header_color_secure_information: "#ffffff",
  header_color_secure_information_border_focus: "#ffffff",
  header_color_secure_information_background: "#365c7d",
  header_color_secure_information_background_hover: "#365c7d",
  header_color_secure_information_focus: "#ffffff",
  header_color_secure_information_hover: "#ffffff",
  header_color_secure_information_icon_default: "#ffffff",
  header_color_secure_information_icon_focus: "#ffffff",
  header_color_secure_information_icon_hover: "#ffffff",
  header_color_auth_background: "#e6f3f6",
  header_color_auth_background_focus: "#4e75af",
  header_color_auth_background_hover: "rgba(0, 0, 0, 0)",
  header_color_auth_foreground: "#107987",
  header_color_auth_foreground_focus: "#ffffff",
  header_color_auth_foreground_hover: "#0c5963",
  heading_color_default: "#00284c",
  heading_color_brand: "#00284c",
  heading_color_inverse_default: "#ffffff",
  heading_color_inverse_brand: "#ffffff",
  hr_color: "#adadad",
  link_color: "#107987",
  link_color_background_focus: "#4e75af",
  link_color_background_pressed: "#4e75af",
  link_color_focus: "#ffffff",
  link_color_hover: "#0c5963",
  notification_color_standalone_background: "#e6f3f6",
  notification_color_standalone_background_information: "#e6f3f6",
  notification_color_standalone_background_critical: "#e6f3f6",
  notification_color_standalone_background_success: "#e6f3f6",
  notification_color_standalone_background_warning: "#e6f3f6",
  notification_color_standalone_body_background: "#e6f3f6",
  notification_color_standalone_body_background_information: "#e6f3f6",
  notification_color_standalone_body_background_critical: "#e6f3f6",
  notification_color_standalone_body_background_success: "#e6f3f6",
  notification_color_standalone_body_background_warning: "#e6f3f6",
  notification_color_standalone_border_information: "#0d6c95",
  notification_color_standalone_border_critical: "#ce2244",
  notification_color_standalone_border_success: "#427d3e",
  notification_color_standalone_border_warning: "#cc4e00",
  notification_color_standalone_icon_information: "#0d6c95",
  notification_color_standalone_icon_critical: "#ce2244",
  notification_color_standalone_icon_success: "#427d3e",
  notification_color_standalone_icon_warning: "#cc4e00",
  notification_color_standalone_no_children_border_information: "#0d6c95",
  notification_color_standalone_no_children_border_critical: "#ce2244",
  notification_color_standalone_no_children_border_success: "#427d3e",
  notification_color_standalone_no_children_border_warning: "#cc4e00",
  notification_color_critical_action_default: "#00284c",
  notification_color_critical_action_focus: "#ffffff",
  notification_color_critical_action_hover: "#00284c",
  notification_color_critical_action_pressed: "#ffffff",
  notification_color_information_action_default: "#00284c",
  notification_color_information_action_focus: "#ffffff",
  notification_color_information_action_hover: "#00284c",
  notification_color_information_action_pressed: "#ffffff",
  notification_color_success_action_default: "#00284c",
  notification_color_success_action_focus: "#ffffff",
  notification_color_success_action_hover: "#00284c",
  notification_color_success_action_pressed: "#ffffff",
  notification_color_warning_action_default: "#00284c",
  notification_color_warning_action_focus: "#ffffff",
  notification_color_warning_action_hover: "#00284c",
  notification_color_warning_action_pressed: "#ffffff",
  numberfield_color: "#107987",
  numberfield_color_disabled: "#767676",
  numberfield_color_focus: "#0c5963",
  numberfield_color_hover: "#0c5963",
  numberfield_color_pressed: "#0c5963",
  page_default1_color_background: "#ffffff",
  page_default2_color_background: "#ffffff",
  selector_color_foreground_checked: "#ffffff",
  summarybox_color: "#00284c",
  summarybox_color_background: "#e6f3f6",
  summarybox_color_background_grey: "#e6f3f6",
  summarybox_color_tertiary_border: "#e6f3f6",
  summarybox_color_border: "#0d6c95",
  summarybox_info_body_color_text: "#00284c",
  summarybox_info_heading_color_text: "#00284c",
  summarybox_primary_body_color_text: "#00284c",
  summarybox_primary_heading_color_text: "#00284c",
  summarybox_secondary_body_color_text: "#00284c",
  summarybox_secondary_heading_color_text: "#00284c",
  summarybox_tertiary_body_color_text: "#00284c",
  summarybox_tertiary_border: "#0c5963",
  summarybox_tertiary_heading_color_text: "#00284c",
  table_color_border: "#107987",
  table_header_color_background: "#f1f1f1",
  tabs_tabs_color_background: "rgba(0, 0, 0, 0)",
  tabs_inpage_accordion_tabs_border: "#adadad",
  tabs_inpage_accordion_tab_color_background_common: "rgba(0, 0, 0, 0)",
  tabs_inpage_accordion_tab_color_background_selected_common: "rgba(0, 0, 0, 0)",
  tabs_inpage_accordion_tab_color_border_default: "#adadad",
  tabs_inpage_accordion_tab_color_border_hover: "#adadad",
  tabs_inpage_accordion_tab_color_border_focus: "rgba(0, 0, 0, 0)",
  tabs_inpage_accordion_tab_color_border_pressed: "#adadad",
  tabs_inpage_accordion_tab_color_border_selected_default: "#adadad",
  tabs_inpage_accordion_tab_color_border_selected_hover: "#adadad",
  tabs_inpage_accordion_tab_color_border_selected_focus: "rgba(0, 0, 0, 0)",
  tabs_inpage_accordion_tab_color_border_selected_pressed: "#adadad",
  tabs_inpage_accordion_tab_color_text_default: "#107987",
  tabs_inpage_accordion_tab_color_text_hover: "#0c5963",
  tabs_inpage_accordion_tab_color_text_focus: "#0c5963",
  tabs_inpage_accordion_tab_color_text_pressed: "#0c5963",
  tabs_inpage_accordion_tab_color_text_selected_default: "#107987",
  tabs_inpage_accordion_tab_color_text_selected_hover: "#0c5963",
  tabs_inpage_accordion_tab_color_text_selected_focus: "#0c5963",
  tabs_inpage_accordion_tab_color_text_selected_pressed: "#0c5963",
  tabs_inpage_accordion_tab_color_icon_default: "#107987",
  tabs_inpage_accordion_tab_color_icon_hover: "#0c5963",
  tabs_inpage_accordion_tab_color_icon_focus: "#0c5963",
  tabs_inpage_accordion_tab_color_icon_pressed: "#0c5963",
  tabs_inpage_accordion_tab_color_icon_selected_default: "#107987",
  tabs_inpage_accordion_tab_color_icon_selected_hover: "#0c5963",
  tabs_inpage_accordion_tab_color_icon_selected_focus: "#0c5963",
  tabs_inpage_accordion_tab_color_icon_selected_pressed: "#0c5963",
  tabs_inpage_tab_color_background_common: "rgba(0, 0, 0, 0)",
  tabs_inpage_tab_color_background_selected_common: "rgba(0, 0, 0, 0)",
  tabs_inpage_tab_color_border_common: "#00284c",
  tabs_inpage_tab_color_border_selected_common: "#107987",
  tabs_inpage_tab_color_text_common: "#107987",
  tabs_inpage_tab_color_text_selected_common: "#107987",
  tabs_inpage_tab_color_icon_common: "#107987",
  tabs_inpage_tab_color_icon_selected_common: "#107987",
  tabs_standalone_accordion_tab_color_background_default: "rgba(0, 0, 0, 0)",
  tabs_standalone_accordion_tab_color_background_hover: "#ffffff",
  tabs_standalone_accordion_tab_color_background_focus: "#ffffff",
  tabs_standalone_accordion_tab_color_background_pressed: "#ffffff",
  tabs_standalone_accordion_tab_color_background_selected_common: "rgba(0, 0, 0, 0)",
  tabs_standalone_accordion_tab_color_border_default: "#107987",
  tabs_standalone_accordion_tab_color_border_hover: "#0c5963",
  tabs_standalone_accordion_tab_color_border_focus: "#4e75af",
  tabs_standalone_accordion_tab_color_border_pressed: "#0c5963",
  tabs_standalone_accordion_tab_color_border_selected_common: "#107987",
  tabs_standalone_accordion_tab_color_text_default: "#107987",
  tabs_standalone_accordion_tab_color_text_hover: "#0c5963",
  tabs_standalone_accordion_tab_color_text_focus: "#0c5963",
  tabs_standalone_accordion_tab_color_text_pressed: "#0c5963",
  tabs_standalone_accordion_tab_color_text_selected_common: "#000000",
  tabs_standalone_accordion_tab_color_icon_default: "#107987",
  tabs_standalone_accordion_tab_color_icon_hover: "#0c5963",
  tabs_standalone_accordion_tab_color_icon_focus: "#0c5963",
  tabs_standalone_accordion_tab_color_icon_pressed: "#0c5963",
  tabs_standalone_accordion_tab_color_icon_selected_common: "#ffffff",
  tabs_standalone_tab_color_background_default: "rgba(0, 0, 0, 0)",
  tabs_standalone_tab_color_background_hover: "#ffffff",
  tabs_standalone_tab_color_background_focus: "#ffffff",
  tabs_standalone_tab_color_background_pressed: "#ffffff",
  tabs_standalone_tab_color_background_selected_common: "#107987",
  tabs_standalone_tab_color_border_default: "#107987",
  tabs_standalone_tab_color_border_hover: "#0c5963",
  tabs_standalone_tab_color_border_focus: "#4e75af",
  tabs_standalone_tab_color_border_pressed: "#4e75af",
  tabs_standalone_tab_color_border_selected_common: "#107987",
  tabs_standalone_tab_color_text_default: "#107987",
  tabs_standalone_tab_color_text_hover: "#0c5963",
  tabs_standalone_tab_color_text_focus: "#0c5963",
  tabs_standalone_tab_color_text_pressed: "#0c5963",
  tabs_standalone_tab_color_text_selected_default: "#ffffff",
  tabs_standalone_tab_color_text_selected_hover: "#ffffff",
  tabs_standalone_tab_color_text_selected_focus: "#ffffff",
  tabs_standalone_tab_color_text_selected_pressed: "#ffffff",
  tabs_standalone_tab_color_icon_default: "#107987",
  tabs_standalone_tab_color_icon_hover: "#0c5963",
  tabs_standalone_tab_color_icon_focus: "#0c5963",
  tabs_standalone_tab_color_icon_pressed: "#0c5963",
  tabs_standalone_tab_color_icon_selected_default: "#ffffff",
  tabs_standalone_tab_color_icon_selected_hover: "#ffffff",
  tabs_standalone_tab_color_icon_selected_focus: "#ffffff",
  tabs_standalone_tab_color_icon_selected_pressed: "#ffffff",
  tooltip_overlay_color_background: "#107987",
  confirmation_color_border: "#0d6c95",
  transition_duration_default: "0.10s",
  transition_duration_very_fast: "0.10s",
  transition_duration_very_slow: "0.50s",
  transition_duration_fast: "0.20s",
  transition_duration_normal: "0.30s",
  transition_duration_slow: "0.40s",
  accordion_button_config_font_weight: "bold",
  button_config_font_weight: "bold",
  confirmation_config_bgcolor: "success",
  contentgroup_config_as_box: false,
  grid_config_columns: 12,
  header_config_button_font_weight: "bold",
  header_config_logout_text: "Log out",
  selector_config_font_weight: "bold",
  summarybox_config_show_variations: false,
  backgrounds_config_action_tertiary_foreground_alternate: ["#fae9ec", "#e7f0f4", "#ecf2ec", "#faede6"],
  button_inverse_box_shadow_focus_css: "0 0 0 0.125rem #ffffff, 0 0 0 0.25rem #4e75af",
  button_box_shadow_focus_css: "0 0 0 0.125rem #ffffff, 0 0 0 0.25rem #4e75af",
  numberfield_border_radius_down_css: "0.375rem 0 0 0.375rem",
  numberfield_border_radius_up_css: "0 0.375rem 0.375rem 0",
  numberfield_button_border_css: "0.125rem solid transparent",
  numberfield_width_css: "auto",
  input_border_style_disabled_css: "dashed",
  input_box_shadow_focus_css: "0 0 0 0.125rem #ffffff, 0 0 0 0.25rem #4e75af",
  icon_height_s1_default_css: "50%",
  icon_height_s1_md_css: "0.875rem",
  icon_height_s1_lg_css: "100%",
  icon_height_s2_default_css: "50%",
  icon_height_s2_md_css: "1rem",
  icon_height_s2_lg_css: "100%",
  icon_height_s3_default_css: "50%",
  icon_height_s3_md_css: "1.125rem",
  icon_height_s3_lg_css: "100%",
  icon_height_s4_default_css: "50%",
  icon_height_s4_md_css: "1.125rem",
  icon_height_s4_lg_css: "100%",
  transition_easing_standard_css: "cubic-bezier(0.4, 0, 0.4, 1)",
  typography_font_family_css: "\"Open Sans v15 Latin\", system-ui, sans-serif",
  typography_font_weight_normal_css: "400",
  typography_font_weight_bold_css: "600",
  typography_font_weight_default_css: "400",
  typography_line_height_s1_css: "1.25",
  typography_line_height_s2_css: "1.3333333333333333",
  typography_line_height_s3_css: "1.4",
  typography_line_height_s4_css: "1.1666666666666667",
  typography_line_height_s5_css: "1.125",
  typography_line_height_s6_css: "1.1111111111111112",
  typography_line_height_s7_css: "1.2",
  typography_line_height_s7_md_css: "1.0833333333333333",
  typography_line_height_s8_css: "1.2",
  typography_line_height_s8_md_css: "1.0833333333333333",
  typography_line_height_s9_css: "1.2",
  typography_line_height_s9_md_css: "1.0833333333333333",
  typography_line_height_s10_css: "1.2",
  typography_line_height_s10_md_css: "1.0833333333333333",
  typography_heading_font_family_css: "\"Full Slab\", system-ui, sans-serif",
  typography_heading_line_height_s2_css: "1.3333333333333333",
  typography_heading_line_height_s3_css: "1.4",
  typography_heading_line_height_s4_css: "1.1666666666666667",
  typography_heading_line_height_s5_css: "1.125",
  typography_heading_line_height_s6_css: "1.1111111111111112",
  typography_heading_line_height_s7_css: "1.2",
  typography_heading_line_height_s7_md_css: "1.0833333333333333",
  typography_text_font_family_css: "\"Open Sans v15 Latin\", system-ui, sans-serif",
  typography_text_line_height_s1_css: "1.25",
  typography_text_line_height_s2_css: "1.3333333333333333",
  typography_text_line_height_s3_css: "1.4",
  typography_text_line_height_s4_css: "1.1666666666666667",
  typography_text_line_height_s5_css: "1.125",
  accordion_button_css_box_shadow_focus: "0 0 0 0.125rem #ffffff, 0 0 0 0.25rem #4e75af",
  accordion_standalone_body_css_padding: "0 0.75rem 0.75rem",
  accordion_standalone_body_css_padding_md: "0.5rem 1.5rem 1.5rem",
  accordion_inpage1_body_css_padding: "0 0 0.75rem",
  accordion_inpage1_body_css_padding_md: "0 0 1rem",
  accordion_inpage2_body_css_padding: "0 0 0.75rem",
  accordion_inpage2_body_css_padding_md: "0 0 1rem",
  checkbox_marker_icon_css: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21.5078 6.85529C22.2296 6.13336 22.1576 4.91857 21.2912 4.29517C20.6129 3.80612 19.659 3.94987 19.0673 4.54132L9.0203 14.5875C8.65356 14.9551 8.05725 14.9551 7.68977 14.5875L3.93281 10.8311C3.34037 10.2395 2.38715 10.0946 1.70816 10.5841C0.842481 11.2072 0.770423 12.4232 1.49229 13.1449L7.68492 19.3385C8.05479 19.7064 8.65282 19.7064 9.0211 19.3385L21.5078 6.85529Z\" fill=\"#107987\"/>\n</svg>",
  dialog_mask_background_color_css: "rgba(51, 51, 51, 0.64)",
  heading_font_weight_default_css: "500",
  heading_font_weight_normal_css: "500",
  heading_font_weight_bold_css: "500",
  heading_s2_font_weight_default_css: "500",
  heading_s2_font_weight_normal_css: "500",
  heading_s2_font_weight_bold_css: "500",
  heading_s2_line_height_css: "1.3333333333333333",
  heading_s3_font_weight_default_css: "500",
  heading_s3_font_weight_normal_css: "500",
  heading_s3_font_weight_bold_css: "500",
  heading_s3_line_height_css: "1.4",
  heading_s4_font_weight_default_css: "500",
  heading_s4_font_weight_normal_css: "500",
  heading_s4_font_weight_bold_css: "500",
  heading_s4_line_height_css: "1.1666666666666667",
  heading_s5_font_weight_default_css: "500",
  heading_s5_font_weight_normal_css: "500",
  heading_s5_font_weight_bold_css: "500",
  heading_s5_line_height_css: "1.125",
  heading_s6_font_weight_default_css: "500",
  heading_s6_font_weight_normal_css: "500",
  heading_s6_font_weight_bold_css: "500",
  heading_s6_line_height_css: "1.1111111111111112",
  heading_s7_font_weight_default_css: "500",
  heading_s7_font_weight_normal_css: "500",
  heading_s7_font_weight_bold_css: "500",
  heading_s7_line_height_css: "1.2",
  heading_s7_line_height_md_css: "1.0833333333333333",
  link_box_shadow_focus_css: "0 0 0 0.125rem #4e75af, 0 0 0 0.25rem #ffffff",
  link_static_text_decoration_css: "none",
  link_static_text_decoration_hover_css: "underline",
  link_text_decoration_css: "underline",
  link_text_decoration_hover_css: "none",
  notification_standalone_body_padding_css: "0 calc(0.75rem - 0.125rem) 0.75rem",
  notification_standalone_body_padding_wide_css: "0 1.5rem 1.5rem 4.125rem",
  notification_standalone_header_padding_css: "calc(0.75rem - 0.125rem) calc(0.75rem - 0.125rem) 1.5rem",
  notification_standalone_header_padding_wide_css: "calc(1.5rem - 0.125rem) calc(1.5rem - 0.125rem) 1.5rem",
  tabs_tab_css_box_shadow_focus: "0 0 0 0.125rem #ffffff, 0 0 0 0.25rem #4e75af",
  text_font_weight_normal_css: "400",
  text_font_weight_bold_css: "600",
  text_s1_line_height_css: "1.25",
  text_s2_line_height_css: "1.3333333333333333",
  text_s3_line_height_css: "1.4",
  text_s4_line_height_css: "1.1666666666666667",
  text_s5_line_height_css: "1.125",
  typography_font_default: "\"Open Sans v15 Latin\"",
  typography_font_brand: "\"Full Slab\"",
  typography_heading_font_default: "\"Full Slab\"",
  typography_text_font_default: "\"Open Sans v15 Latin\""
};
import fonts from "./fonts";
import logo from "./logo";
import { MBNA } from "../../constants";
export default _objectSpread(_objectSpread({}, tokens), {}, {
  assets: {
    fonts: fonts,
    logo: logo
  },
  brand: MBNA
});